import React from 'react';
import PropTypes from 'prop-types';

const GlowingText = ({ 
  children,
  text, 
  as: Component = 'span',
  color = 'violet',
  size = 'md',
  weight = 'bold',
  animation,
  className = ''
}) => {
  // Color mapping
  const colorClasses = {
    violet: 'text-violet-400 drop-shadow-[0_0_10px_rgba(139,92,246,0.5)]',
    blue: 'text-blue-400 drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]',
    cyan: 'text-cyan-400 drop-shadow-[0_0_10px_rgba(34,211,238,0.5)]',
    pink: 'text-pink-400 drop-shadow-[0_0_10px_rgba(244,114,182,0.5)]',
    mixed: 'bg-gradient-to-r from-violet-400 via-blue-500 to-cyan-400 bg-clip-text text-transparent drop-shadow-[0_0_10px_rgba(139,92,246,0.5)]'
  };
  // Size mapping
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl'
  };

  // Weight mapping
  const weightClasses = {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
    extrabold: 'font-extrabold'
  };

  // Animation mapping
  const animationClasses = {
    breathing: 'animate-pulse-glow',
    shine: 'animate-shine',
    none: ''
  };

  const combinedClassName = [
    colorClasses[color] || colorClasses.violet,
    sizeClasses[size] || sizeClasses.md,
    weightClasses[weight] || weightClasses.bold,
    animation && animationClasses[animation],
    'transition-all duration-300',
    className
  ].filter(Boolean).join(' ');
  return (
    <Component className={combinedClassName}>
      {text || children}
    </Component>
  );
};

GlowingText.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  as: PropTypes.elementType,
  color: PropTypes.oneOf(['violet', 'blue', 'cyan', 'pink', 'mixed']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold', 'extrabold']),
  animation: PropTypes.oneOf(['breathing', 'shine', 'none']),
  className: PropTypes.string
};

export default GlowingText;
